document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initCifras();
  initGaleria();
  initVariantes();
  initCantidad();
  initTilt();
  initParallaxHero();
});

/* Parallax suave del visual del hero al hacer scroll (transform, sin layout thrashing) */
function initParallaxHero() {
  var visual = document.querySelector('.eg-hero__visual');
  if (!visual) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function update() {
    var rect = visual.getBoundingClientRect();
    var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
    var offset = (progress - 0.5) * 40;
    visual.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

/* Inclinacion 3D sutil de tarjetas al mover el raton (solo puntero fino, sin reduced-motion) */
function initTilt() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  document.querySelectorAll('.eg-tilt').forEach(function (card) {
    var max = 7;
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width;
      var py = (e.clientY - rect.top) / rect.height;
      card.style.setProperty('--eg-ry', ((px - 0.5) * max * 2) + 'deg');
      card.style.setProperty('--eg-rx', ((0.5 - py) * max * 2) + 'deg');
    });
    card.addEventListener('mouseleave', function () {
      card.style.setProperty('--eg-ry', '0deg');
      card.style.setProperty('--eg-rx', '0deg');
    });
  });
}

/* Revela elementos .eg-reveal al entrar en pantalla, con stagger opcional via --eg-delay */
function initReveal() {
  var els = document.querySelectorAll('.eg-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('eg-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('eg-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

/* Slider de arrastre para comparador antes/despues */
function initComparador() {
  document.querySelectorAll('.eg-slider').forEach(function (slider) {
    var handle = slider.querySelector('.eg-slider__handle');
    var afterWrap = slider.querySelector('.eg-slider__after-wrap');
    if (!handle || !afterWrap) return;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      handle.style.left = pct + '%';
      afterWrap.style.width = pct + '%';
    }
    setPos(50);

    var dragging = false;
    function pointerX(e) {
      var rect = slider.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }
    slider.addEventListener('pointerdown', function (e) { dragging = true; setPos(pointerX(e)); });
    window.addEventListener('pointermove', function (e) { if (dragging) setPos(pointerX(e)); });
    window.addEventListener('pointerup', function () { dragging = false; });
    slider.addEventListener('touchstart', function (e) { dragging = true; setPos(pointerX(e)); }, { passive: true });
    slider.addEventListener('touchmove', function (e) { if (dragging) setPos(pointerX(e)); }, { passive: true });
    window.addEventListener('touchend', function () { dragging = false; });
  });
}

/* Cuenta ascendente para las cifras de especificaciones */
function initCifras() {
  var els = document.querySelectorAll('.eg-cifra__num[data-target]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.dataset.target);
      var suffix = el.dataset.suffix || '';
      var decimals = el.dataset.decimals ? parseInt(el.dataset.decimals, 10) : 0;
      if (reduced) {
        el.textContent = target.toFixed(decimals) + suffix;
        io.unobserve(el);
        return;
      }
      var start = null;
      var duration = 1400;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      io.unobserve(el);
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { io.observe(el); });
}

/* Galeria de producto: click en miniatura cambia la imagen principal */
function initGaleria() {
  document.querySelectorAll('[data-eg-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-eg-main-img]');
    var thumbs = galeria.querySelectorAll('[data-eg-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

/* Selector de variantes: actualiza precio, id oculto y estado del boton */
function initVariantes() {
  document.querySelectorAll('[data-eg-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-eg-variantes-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var swatchGroups = root.querySelectorAll('[data-eg-opcion]');
    var idInput = root.querySelector('[data-eg-variant-id]');
    var priceEl = root.querySelector('[data-eg-precio-actual]');
    var comparePriceEl = root.querySelector('[data-eg-precio-comparado]');
    var addBtn = root.querySelector('[data-eg-add]');
    var stockNote = root.querySelector('[data-eg-stock]');

    function selectedOptions() {
      var opts = [];
      swatchGroups.forEach(function (group) {
        var active = group.querySelector('.is-active');
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return opts;
    }

    function findVariant() {
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === opts[i]; });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function update() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var label = variant.available ? addBtn.getAttribute('data-label-disponible') : addBtn.getAttribute('data-label-agotado');
        var span = addBtn.querySelector('span');
        if (span) { span.textContent = label; } else { addBtn.textContent = label; }
      }
      if (stockNote) stockNote.style.display = variant.available ? '' : 'none';
    }

    swatchGroups.forEach(function (group) {
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          update();
        });
      });
    });

    update();
  });
}

/* Selector de cantidad +/- */
function initCantidad() {
  document.querySelectorAll('[data-eg-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-eg-menos]');
    var plus = wrap.querySelector('[data-eg-mas]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    plus && plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}
